import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { User } from "../../../auth/models";
import { Tender } from "../../models";
import { SealedTenderService } from "../../services";

@Component({
    selector: "jft-tender-reports",
    templateUrl: "./tender-reports.component.html",
    styleUrls: ["./tender-reports.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TenderReportsComponent {
    public tender: Tender;
    // Evaluated once at construction - both flags depend only on the logged-in
    // user and the already-resolved tender, so there's no need to re-compute
    // them on every change-detection tick (template used to call methods inside
    // *ngIf, which fires on every tick).
    public readonly canAccessAggregate: boolean;
    public readonly canViewYearOverYear: boolean;

    constructor(
        route: ActivatedRoute,
        sealedTenderService: SealedTenderService,
        user: User,
    ) {
        this.tender = route.parent.snapshot.data["tender"];
        // Sealed if the viewer OR the tender's owner seals (the server's is_sealed_for_tender):
        // a realtime parent opening a sealed child's tender gets the lock too.
        this.canAccessAggregate =
            sealedTenderService.canAccessAggregateData(user.company, this.tender) &&
            sealedTenderService.canAccessAggregateData(this.tender?.company, this.tender);
        this.canViewYearOverYear = !!user.settings?.view_reports;
    }
}
